import AppRestService from './app-rest.service';
import UserModel from '../models/user.model';



/**
 * Service Endpoint Implementation
 */
export default class UsersService extends AppRestService {

  constructor(opts = null) {
    super(opts);
    this.serviceName = 'users';
    this.routePath = 'users';
    this.idParamName = 'user_id';
    this.modelClass = UserModel;
    this.authEnabled = true;
  }

}

